<template>
  <div>
    <div
      v-if="activeUser && activeUser.id"
      data-component-group="user-dialog"
      data-component="edit"
    >
      <dialog-edit
        icon="account_circle"
        :to="`/users/${activeUser?.id}`"
        :title="userTitle"
        :is-error="isBlockedUser"
        content-class="edit-user-dialog"
        is-fullscreen
        :is-on="true"
        :on-close="onCancel"
      >
        <template v-slot:content>
          <forms-user-edit
            :is-loading="isEditingUser"
            :on-cancel="onCancel"
            :on-submit="$ability.can('update', 'user') ? updateUser : undefined"
            @saved="$emit('saved')"
          />
        </template>
      </dialog-edit>
    </div>
  </div>
</template>

<script>
  import { isStr } from '@/utils';

  export default {
    emits: ['saved'],
    data() {
      return {
        isEditingUser: false,
      };
    },
    created() {
      if (!this.activeUser?.id) {
        this.$store.dispatch('users/getItem', { id: this.$route.params.id });
      }
    },
    computed: {
      activeUser() {
        return this.$store.getters['users/activeItem'];
      },
      parentRoute() {
        return this.$route.matched[0]?.name || 'users';
      },
      userName() {
        const { name = '' } = this.activeUser;
        return name !== '' ? name : this.$t('user_profile');
      },
      isBlockedUser() {
        const { status = {} } = this.activeUser;
        return isStr(status.name) && status.name.toLowerCase() === 'blocked';
      },
      userTitle() {
        const blockedText = this.isBlockedUser ? `(${this.$t('blocked')})` : '';
        return `${this.userName} ${blockedText}`;
      },
    },
    beforeUnmount() {
      this.$store.dispatch('users/clearActiveItem');
    },
    methods: {
      onCancel() {
        this.$router.push({ name: this.parentRoute, query: this.$route.query });
      },
      updateUser(user) {
        const query = {
          ...user,
          id: this.activeUser.id,
        };

        this.isEditingUser = true;

        return this.$store
          .dispatch('users/update', query)
          .then((res) => {
            if (res.data.status === 'success') {
              this.$emit('saved');
              this.$router.push({ name: this.parentRoute, query: this.$route.query });
            }
            return res;
          })
          .finally(() => {
            this.isEditingUser = false;
          });
      },
    },
  };
</script>
